module.exports = __webpack_public_path__ + "img/MentorProtegeButton.4e06a7bf.png";